import React, { useState } from "react";
import { OwlCarousel } from "../../atoms/DependencyHelper";
import CarouselButton from "../../atoms/buttons/carouselButton/CarouselButton";
import styles from "./Carousel.module.scss";
import PropTypes from "prop-types";

const Carousel = ({ children, showNav, center, navClassName,className }) => {

  const [previousNavClass, setPreviousNavClass] = useState("");
  const [nextNavClass, setNextNavClass] = useState("");

  const options = {
    items: 1,
    center: center,
    nav: showNav,
    autoplay: false,
    navContainerClass: "owl--nav--container",
    dotsClass: "owl--dots owl--dots--show",
    dotClass: "owl--dot owl--dot--red",
    animateIn: "animate__fadeIn",
    margin: 0,
    autoWidth: false,
    dots: true,
    slideBy: 1,
    responsive: {
      0: {
        slideBy: 1,
      }
    }
  };

  let carousel;

  const next = () => {
    if (carousel) {
      carousel.next(600);
    }
  };
  const prev = () => {
    if (carousel) {
      carousel.prev(600);
    }
  };

  const events = {
    onInitialized: function (event) {
      toggleCarouselNavDisabled(event);
    },
    onTranslated: function (event) {
      toggleCarouselNavDisabled(event);
    }
  };

  function toggleCarouselNavDisabled(event) {
    const index = event.item.index;
    const minimum = 0;
    const maximum = event.item.count;

    let previousNav = index <= minimum ? "disabled" : "";
    let nextNav =
      index +
        options.responsive[event.relatedTarget._breakpoint].slideBy >= maximum
        ? "disabled"
        : "";
    
    setPreviousNavClass(previousNav);
    setNextNavClass(nextNav);
  }

  return (
    <div className={`${styles["carousel-container"]} ${className} owl-wrapper`}>
      <OwlCarousel ref={(c) => (carousel = c)} options={options} events={events}>
        {children}
      </OwlCarousel>
      {showNav && (
        <div className={`custom-owl--nav ${navClassName ? navClassName : ""}`}>
          <CarouselButton
            prev
            handleClick={prev}
            className={`${styles["arrow"]} ${styles["arrow--prev"]} ${previousNavClass}`}
            btnSize="sm"
            id="Carousel_arrowBackBtn"
          />
          <CarouselButton
            next
            handleClick={next}
            className={`${styles["arrow"]} ${styles["arrow--next"]} ${nextNavClass}`}
            btnSize="sm"
            id="Carousel_arrowNextBtn"
          />
        </div>
      )}
    </div>
  );
};

Carousel.propTypes = {
  children: PropTypes.node,
  showNav: PropTypes.bool,
  center: PropTypes.bool,
  navClassName: PropTypes.string,
};

export default Carousel;
